<template>
  <div id="app" class="app-young">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  overflow: visible;
  -webkit-overflow-scrolling: touch;
}
#app {
  width: 100%;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
body {
  position: relative;
}
::v-deep .van-overflow-hidden {
  overflow: visible !important;
  overflow-x: visible !important;
  overflow-y: visible !important;
}
.noticeWidth {
  min-width: 260px !important;
}
</style>
